import AddressPage from 'components/Commerce/AddressPage';
import LayoutCommerce from 'components/layouts/LayoutCommerce';
import getMenus from 'lib/get-menus';
import { GetStaticPropsResult } from 'next';
import { DrupalMenuLinkContent } from 'next-drupal';
import { ReactElement } from 'react';
interface AddressProps {
  menus: {
    main: DrupalMenuLinkContent[];
    footer: DrupalMenuLinkContent[];
    stickyShop: DrupalMenuLinkContent[];
  };
}
function Address() {
  return <AddressPage />;
}

Address.getLayout = (page: ReactElement) => {
  return <LayoutCommerce {...page.props}>{page}</LayoutCommerce>;
};

export async function getStaticProps(
  context
): Promise<GetStaticPropsResult<AddressProps>> {
  // Load additional ressources if needed.
  const menus = await getMenus(context);

  return {
    props: {
      menus,
    },
    // Next.js will attempt to re-generate the page:
    // - When a request comes in
    // - At most once every 10 seconds
    revalidate: 10, // In seconds
  };
}

export default Address;
